// extracted by mini-css-extract-plugin
export var boldText = "_3e-4";
export var checkboxContainer = "_3e-6";
export var closeIcon = "_3e-i";
export var container = "_3e-0";
export var drawer = "_3e-8";
export var drawerContent = "_3e-9";
export var extraSmallText = "_3e-5";
export var fulfillmentGroupTable = "_3e-e";
export var largeText = "_3e-3";
export var loadingSpinnerContainer = "_3e-j";
export var mediumText = "_3e-2";
export var narrow = "_3e-f";
export var notificationLink = "_3e-l";
export var packageCheckIconContainer = "_3e-7";
export var slideoutHeaderActions = "_3e-g";
export var slideoutHeaderActionsShifted = "_3e-h";
export var slideoutHeaderContainer = "_3e-a";
export var slideoutModal = "_3e-c";
export var stickyHeaderWrapper = "_3e-b";
export var table = "_3e-k";
export var tableContainer = "_3e-d";
export var tertiaryText = "_3e-1";